export default __webpack_public_path__ + "static/media/uniq_campaign.6404a3ef.svg";